import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { HubLoanerPhoneListFacade } from './hub-loaner-phone-list.facade';

@Injectable({
  providedIn: 'root',
})
export class HubLoanerPhoneListGuard {
  constructor(private hubLoanerPhoneListFacade: HubLoanerPhoneListFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { hubId },
    } = route;
    return loadStoreState(this.hubLoanerPhoneListFacade, hubId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.hubLoanerPhoneListFacade);
  }
}
